import { useQuery } from '@tanstack/react-query';
import apiClient from '@/services/client';
import { endpoints } from '@/services/endpoints';
import { getRefreshConfig } from '@/config/refresh.config';

export const useAdminStats = () => {
  const statsQuery = useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: async () => {
      const response = await apiClient.get(endpoints.admin.stats);
      return response.data?.data ?? response.data ?? {};
    },
    staleTime: 0,
    gcTime: 2 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    ...getRefreshConfig('critical'),
  });

  const stats = statsQuery.data ?? {};

  return {
    ...statsQuery,
    stats,
    isLoading: statsQuery.isLoading,
    isError: statsQuery.isError,
    error: statsQuery.error,
  };
};

export default useAdminStats;
